import { Pipe, PipeTransform } from '@angular/core';
import { RoiService, VehicleDamageType } from '../service/roi.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import 'parse';
const parse: typeof Parse = require('parse');

@Pipe({
  name: 'vehicleDamage'
})
export class VehicleDamagePipe implements PipeTransform {
  damageStrings: VehicleDamageType;
  defaultDamage = this.i18n({
    id: 'roi_vehicleDamageTypes_defaultDamage',
    value: 'Type inconnu',
    description: 'Type inconnu',
    meaning: 'roiService'
  });

  constructor(private readonly i18n: I18n,
    private readonly _roiService: RoiService) {
    this.damageStrings = _roiService.vehicleDamageTypes;
  }

  transform(value: any, args?: any): any {
    return this.damageStrings[value] || value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/vehicle-damage.pipe.ts